import React from 'react';
import { purchaseAnchor } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = purchaseAnchor,
  className = ''
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`block w-full text-center cursor-pointer px-3 py-3 sm:py-3.5 font-heading font-bold text-sm sm:text-lg uppercase tracking-wide rounded-md bg-brand-magenta text-white hover:bg-[#F0589A] hover:scale-[1.02] transition-all duration-200 border-b-4 border-brand-magentaDark active:border-b-0 active:translate-y-1 shadow-[0_5px_14px_rgba(229,71,136,0.4)] leading-tight ${className}`} data-id="element-29" data-mp="2fz20qldwwuuz">
      {children}
    </a>;
}